import { queryOptions } from '@tanstack/react-query'

import { fetchAdminPlans } from './admin-plans-api'

export const adminPlanKeys = {
  all: ['admin-plans'] as const,
  list: () => [...adminPlanKeys.all, 'list'] as const,
}

export const adminPlansQuery = () =>
  queryOptions({
    queryKey: adminPlanKeys.list(),
    queryFn: ({ signal }) => fetchAdminPlans(signal),
  })
